import { ShieldAlert } from "lucide-react";

export default function ScamWarning() {
  return (
    <div
      data-testid="scam-warning"
      className="border border-warn-text bg-warn-bg p-6 text-warn-text"
    >
      <div className="flex items-start gap-3">
        <ShieldAlert className="mt-0.5 h-6 w-6 shrink-0" strokeWidth={1.75} />
        <div>
          <h3 className="font-serif text-xl font-semibold">Avoid support scams</h3>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed">
            We are an independent directory. <strong>We never call you, never ask for
            payment, gift cards, remote access, passwords, or one-time codes.</strong> Real
            support agents don&apos;t either. If anyone reaching out asks for these, hang up.
            Always dial the number yourself using the official source linked above.
          </p>
        </div>
      </div>
    </div>
  );
}
